module.exports = __webpack_public_path__ + "static/analytics2-2ad97f546c76c1bf6ffafeb3f3c89ff2.jpg";